import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Sparkles } from 'lucide-react';

export const PricingCTA: React.FC = () => {
  const navigate = useNavigate();

  return (
    <section
      aria-label="Começar a usar"
      className="max-w-3xl mx-auto mb-16 sm:mb-20 text-center rounded-3xl border border-primary-500/30 bg-gradient-to-br from-primary-500/10 via-neutral-900/60 to-neutral-900/60 backdrop-blur-xl p-8 sm:p-12"
    >
      <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/10 border border-primary-500/30 text-primary-400 text-xs font-semibold uppercase tracking-wide mb-6">
        <Sparkles className="w-3.5 h-3.5" />
        Teste grátis
      </div>

      <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-4">
        Pronto para coletar respostas melhores?
      </h2>
      <p className="text-base sm:text-lg text-neutral-400 mb-8 max-w-xl mx-auto">
        Crie sua primeira conta em menos de 1 minuto. Sem cartão, sem ligação de vendedor.
      </p>

      <button
        type="button"
        onClick={() => navigate('/auth/register')}
        className="min-h-[44px] px-6 sm:px-8 py-3 rounded-xl bg-primary-600 hover:bg-primary-700 text-white font-medium text-base transition-colors"
      >
        Criar conta grátis
      </button>
    </section>
  );
};
